module.exports = __webpack_public_path__ + "img/company.d097662b.png";